import { useEffect } from "react";

import ErrorStatus from "@/components/ErrorStatus";
import { captureException } from "@/observability/sentry";

export default function AppErrorComponent({ error }: { error: Error }) {
  useEffect(() => {
    captureException(error);
  }, [error]);

  return <ErrorStatus />;
}
